import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import CheckedMarkIcon from '../../assets/icons/Checkmark.png';
import { IPlan } from '../Plans/Plans';
import OctaIcon from '../../assets/icons/Octa.png';

import styles from './PlanCard.module.scss';

type PlanCardProps = {
  plan: IPlan;
  selected: boolean;
}

const PlanCard: FC<PlanCardProps> = ({ plan, selected }) => {
  return (
    <Box>
      <Box className={`${styles.radioOption} ${selected ? styles.selected : ""}`}>
        <Box className={styles.mainInfo}>
          <Typography variant='h4Bold' className={styles.title}>
            {plan.type}
            {plan.type === "Elite" && <img src={OctaIcon} alt='checked' />}
          </Typography>
          {/* <Typography variant='h11' className={styles.subtitle}>{plan.subtitle}</Typography> */}
          <Typography variant="h6Bold" className={styles.payment}>
            ${Math.floor(plan.price_in_cents / 100)}
            <sup style={{ fontSize: '0.6em', marginLeft: '1px' }}>
              {(plan.price_in_cents % 100).toString().padStart(2, '0')}
            </sup>
            <Typography variant="h13" component="span" sx={{ marginLeft: '4px' }}>
              /year
            </Typography>
          </Typography>
          <Box className={styles.benefitsGroup}>
            {plan.benefits.map((benefit, index) => (
              <Box key={index} className={styles.benefitWrapper}>
                <img src={CheckedMarkIcon} className={styles.benefitIcon} alt='checked-mark' />
                <Typography variant='h12' className={styles.benefit}>{benefit}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box className={styles.termsWrapper}>
          {plan.type === 'Basic' ? (
            <Typography variant='h10Bold' className={selected ? styles.selectedTerms : styles.terms}>
              Get started
            </Typography>
          ) : (
            <Typography variant='h10Bold' className={selected ? styles.selectedTerms : styles.terms}>
              Start 3-day trial
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
};

export default PlanCard;
